import { useApiWrapper } from "../../../../hooks/useApiWrapper";
import { bookingType } from "../../../../types/forms/booking";
import { BookingByIdType, BookingQuery, getAllBookings } from "../../../../types/response/booking";
import { ApiResponse } from "../../../../types/shared";
import { Api } from "../Api";

export const Endpoints = Api.injectEndpoints({
  endpoints: (builder) => ({
    getBooking: builder.query<ApiResponse<getAllBookings>,Partial<BookingQuery>>({
      query: ({
        club_id,
        name,
        limit = 10,
        currentPage = 1,
        booking_type = "",
        court_name = "",
        court_type = "",
        coach_name = "",
        player_name = "",
        date_from = "",
        date_to = "",
        column="",
        order=""
      }) => ({
        url: `/club/booking_test/${club_id}?page=${currentPage}&limit=${limit}&name=${name}&booking_type=${booking_type.toLowerCase()}&court_name=${court_name}&court_type=${court_type.toLowerCase()}&coach_name=${coach_name}&player_name=${player_name}&date_from=${date_from}&date_to=${date_to}&column=${column}&order=${order}`,
      }),
      providesTags: ["booking", "booking-all"],
    }),
    getFakeBooking: builder.query<ApiResponse<getAllBookings>,Partial<BookingQuery>>({
      query: ({
        club_id,
        name,
        limit = 10,
        currentPage = 1,
        booking_type = "",
        court_name = "",
        court_type = "",
        coach_name = "",
        player_name = "",
        date_from = "",
        date_to = "",
        column="",
        order=""
      }) => ({
        url: `/club/booking_test/${club_id}?page=${currentPage}&limit=${limit}`,
      }),
      providesTags: ["booking", "booking-all"],
    }),
    deleteBooking: builder.mutation({
      query: ({ bookingId = 0, cancel = "", series_id = "" }) => ({
        url: `/booking/cancel/${bookingId}?cancel=${cancel}&series_id=${series_id}`,
        method: "POST",
      }),
      invalidatesTags: ["booking-all"],
    }),
    getPlayersForBooking: builder.query({
      query: ({
        club_id,
        booking_id=0,
        name = "",
        court_id = "",
        booking_date = "",
        booking_type = "",
        pricePerPlayer=0,
        start_time = "",
        payment_type = "",
        end_time = "",
        coach_id = "",
        number_of_players = "",
        slot = 0,
        recurring,
        min_level = "",
        max_level = "",
      }) => ({
        url: `/club/booking/players/${club_id}?name=${name}&date=${booking_date}&start_time=${start_time}&end_time=${end_time}&court_id=${court_id}&booking_date=${booking_date}&payment_type=${payment_type}&coach_id=${coach_id}&number_of_players=${number_of_players}&slot=${slot}&booking_type=${booking_type}&min_level=${min_level}&max_level=${max_level}&total_price=${pricePerPlayer}&recurring=${recurring}&booking_id=${booking_id}`,
      }),
      providesTags: ["booking-all", "players"],
    }),
    refundForPlayer: builder.mutation({
      query: ({ lineId = 0 }) => ({
        url: `/booking/player/refund/${lineId}`,
        method: "PATCH",
      }),
      invalidatesTags: ["booking-all"],
    }),
    getPlayersForAcademyBooking: builder.query({
      query: ({
        club_id,
        name = "",
        court_id = "",
        booking_date = "",
        start_time = "",
        payment_type = "",
        end_time = "",
        coach_id = "",
        number_of_players = "",
        academyId = "",
        slot = "",
      }) => ({
        url: `/club/academy/players/${club_id}?name=${name}&date=${booking_date}&start_time=${start_time}&end_time=${end_time}&court_id=${court_id}&booking_date=${booking_date}&payment_type=${payment_type}&coach_id=${coach_id}&number_of_players=${number_of_players}&slot=${slot}&club_id=${club_id}&academy_id=${academyId}`,
      }),
      providesTags: ["booking-all", "players"],
    }),
    createBooking: builder.mutation({
      query: ({ data }) => ({
        url: `/club/booking`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["booking-all"],
    }),
     blockCourt: builder.mutation({
      query: ({ data }) => ({
        url: `/club/court_block`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["booking-all"],
    }),
    createPrivateBooking: builder.mutation({
      query: ({ data }) => ({
        url: `/club/booking/private`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["booking-all"],
    }),
    getBookingById: builder.query<ApiResponse<any>,Partial<{bookingId:number}>>({
      query: ({ bookingId }) => ({
        url: `/booking/${bookingId}`,
        method: "GET",
      }),
      providesTags: ["booking-all", "single-booking"],
    }),
    editBooking: builder.mutation({
      query: ({ bookingId, data }) => ({
        url: `/booking/${bookingId}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, arg, meta) => {
        // Only invalidate tags if the status code indicates success
        //@ts-ignore
        if (meta?.response?.status >= 200 && meta?.response?.status < 300) {
          console.log(result?.status);
          return [
            "booking",
            "booking-all",
            "tournament-groups",
            "league-groups",
            "Coach",
            "homeView",
          ];
        }
        return [];
      },
    }),
    editBookingFromBookingPage: builder.mutation({
      query: ({ bookingId, data }) => ({
        url: `/booking/${bookingId}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["booking-all"],
    }),
    editPrivateBooking: builder.mutation({
      query: ({ bookingId, data, series_id }) => ({
        url: `/private/booking/${bookingId}?series=${series_id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["booking-all"],
    }),
    refreshPaymentLink: builder.mutation({
      query: (data) => ({
        url: `/payment/refresh_link`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["single-booking"],
    }),
    removePlayer: builder.mutation({
      query: ({ bookingId, lineId,with_refund=false }) => ({
        url: `/booking/player/cancel/${lineId}?line_id=${lineId}&with_refund=${with_refund}`,
        method: "POST",
      }),
      invalidatesTags: [ "single-booking"],
    }),
  }),
});
export const {
  
  useDeleteBookingMutation,
  useGetPlayersForBookingQuery,
  useCreateBookingMutation,
  useCreatePrivateBookingMutation,
  useGetBookingByIdQuery,
  useEditBookingMutation,
  useRefreshPaymentLinkMutation,
  useEditBookingFromBookingPageMutation,
  useGetPlayersForAcademyBookingQuery,
  useEditPrivateBookingMutation,
  useRefundForPlayerMutation,
  useBlockCourtMutation,
  useGetFakeBookingQuery,
  useRemovePlayerMutation
} = Endpoints;
export const useGetBookingQuery= (query:any,options?:any)=> useApiWrapper(Endpoints.useGetBookingQuery,query,options)